/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerPage
);
